import React, { useEffect, useState } from 'react';
import { Spin, Table } from 'antd';
import '../styles/admin.css';

export default function Admin() {

    const [columns, setColumns] = useState([
        {
            title: 'ลำดับ',
            dataIndex: 'no',
            key: 'no',
            align: 'center',
        },
        {
            title: 'ชื่อ-นามสกุล',
            dataIndex: 'fullName',
            key: 'fullName',
            align: 'center',
        },
    ]);

    const [data, setData] = useState(null);

    // Fetch problem data
    const fetchProblem = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/problem/`, {
                headers: {
                    'x-access-token': localStorage.getItem('token'),
                },
            });
            const json = await res.json();
            const temp = [...columns];

            json.map((data, index) => {
                temp.push({
                    title: data.problem_name,
                    dataIndex: `p${index}`,
                    key: data._id,
                    align: 'center',
                });
            });

            setColumns(temp);
        } catch (error) {
            console.error('Error fetching problem data:', error);
        }
    };

    // Fetch score data
    const fetchScore = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/score/`, {
                headers: {
                    'x-access-token': localStorage.getItem('token'),
                },
            });
            const json = await res.json();

            let resArr = [];
            json.map((data, index) => {
                let user = {
                    key: index,
                    no: index + 1,
                    fullName: `${data.firstName} ${data.lastName}`,
                    align: 'center',
                };
                let scoreRes = [];
                data.score.map((score, scoreIndex) => {
                    scoreRes.push({
                        [`p${scoreIndex}`]: `${score.s1}${score.s2}${score.s3}${score.s4}${score.s5} (${score.p1 + score.p2 + score.p3 + score.p4 + score.p5})`,
                    });
                });

                let flattenedData = {
                    ...user,
                    ...scoreRes.reduce((acc, score) => {
                        let key = Object.keys(score)[0];
                        acc[key] = score[key];
                        return acc;
                    }, {}),

                };


                resArr.push(flattenedData);
            });

            setData(resArr);
        } catch (error) {
            console.error('Error fetching score data:', error);
        }
    };

    // Use `useEffect` to fetch problem and score data when component mounts
    useEffect(() => {
        fetchProblem();
        fetchScore();
    }, []); // Empty array ensures this runs only once after the initial render



    if (!data) {
        return <Spin />
    }

    return (

        <Table bordered columns={columns} dataSource={data} size='small' />

    )
}
